import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import DetailsIcon from "@material-ui/icons/Details";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Paper from "@material-ui/core/Paper";
import Slide from "@material-ui/core/Slide";
import Slider from "@material-ui/core/Slider";
import Collapse from "@material-ui/core/Collapse";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import ArrowRightRoundedIcon from "@material-ui/icons/ArrowRightRounded";
import FlagRoundedIcon from "@material-ui/icons/FlagRounded";
import { pushLoader } from "../../actions/main";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import moment from "moment";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Arrivallist from "./arrivallist";
import Departurelist from "./departurelist";
import { NavLink, withRouter } from "react-router-dom";

import fetch from "node-fetch";

// import api
import {
  fetchVesselDetailMT,
  pushFavorite,
  fetchVesselbyship_id
} from "../../api/portal";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  customizeToolbar: {
    minHeight: 36
  }
}));

let data = [];

class Poipopup extends Component {
  constructor(props) {
    super(props);
    const {
      baloonTitle,
      jenis,
      hdg,
      typenya,
      geomtype,
      course,
      elapsed,
      heading,
      lat,
      lon,
      shipname,
      shiptype,
      ship_id,
      speed,
      status_name,
      type_img,
      type_name,
      id,
      Tanggal,
      Jam,
      DateTime,
      Lintang,
      Bujur,
      Magnitude,
      Kedalaman,
      Wilayah,
      Potensi,
      Dirasakan,
      Coordinates,
      Shakemap,
      destination,
      rot,
      dwt,
      width,
      length,
      weather,
      date_created
    } = this.props;
    this.state = {
      id: 0,
      baloonTitle: baloonTitle,
      jenis: jenis,
      name: "",
      hdg: hdg,
      typenya: typenya,
      geomtype: geomtype,
      course: course,
      elapsed: elapsed,
      heading: heading,
      lat: lat,
      lon: lon,
      shipname: shipname,
      shiptype: shiptype,
      ship_id: "-",
      ship_idx: "",
      speed: speed,
      status_name: status_name,
      type_img: type_img,
      type_name: type_name,
      id: id,
      open: false,
      Tanggal: Tanggal,
      Jam: Jam,
      DateTime: DateTime,
      Lintang: Lintang,
      Bujur: Bujur,
      Magnitude: Magnitude,
      Kedalaman: Kedalaman,
      Wilayah: Wilayah,
      Potensi: Potensi,
      Dirasakan: Dirasakan,
      Coordinates: Coordinates,
      Shakemap: Shakemap,
      destination: destination,
      rot: rot,
      width: width,
      length: length,
      mmsi: "",
      status: "",
      timestamp: "",
      ais_type_summary: "",
      passenger: "",
      imo: "",
      callsign: "",
      flag: "",
      port_id: "",
      port_unlocode: "",
      current_port: "",
      last_port_id: "",
      last_port_unlocode: "",
      last_port: "",
      last_port_time: "",
      eta: "",
      eta_calc: "",
      length: "",
      width: "",
      draught: "",
      grt: "",
      next_port_id: "",
      next_port_unlocode: "",
      next_port_name: "",
      next_port_country: "",
      year_built: "",
      dsrc: "",
      current_offset: "",
      weather: "",
      temp: "-",
      date_created: ""
    };
  }

  getNameshiptype = shiptype => {
    let shipTypeString;
    switch (shiptype) {
      case 1:
        shipTypeString = "Unspecified Ships";
        break;
      case 2:
        shipTypeString = "Fishing";
        break;
      case 3:
        shipTypeString = "Tugs & Special Craft";
        break;
      case 4:
        shipTypeString = "High Speed Craft";
        break;
      case 5:
        shipTypeString = "Pleasure Craft";
        break;
      case 6:
        shipTypeString = "Passenger Vessel";
        break;
      case 7:
        shipTypeString = "Cargo Vessel";
        break;
      case 8:
        shipTypeString = "Tanker";
        break;

      case 99:
        shipTypeString = "Pertamina";
        break;
      default:
        shipTypeString = "n/a";
        break;
    }

    return shipTypeString;
  };

  UNSAFE_componentWillMount() {}

  UNSAFE_componentWillReceiveProps(nextProps) {
    // if(){
    //   let descdetail = nextProps.description.split(",");
    //
    //   this.setState({current_offset: descdetail[1]});
    // }

    this.setState({ open: false });
    let str = "-";
    if (typeof nextProps.ship_id != "undefined") {
      if (nextProps.ship_id.length <= 8) {
        str = nextProps.ship_id;
      }
    }

    this.setState({
      baloonTitle: nextProps.baloonTitle,
      jenis: nextProps.jenis,
      name: nextProps.name,
      hdg: nextProps.hdg,
      typenya: nextProps.typenya,
      geomtype: nextProps.geomtype,
      course: nextProps.course,
      elapsed: nextProps.elapsed,
      heading: nextProps.heading,
      lat: nextProps.lat,
      lon: nextProps.lon,
      weather: nextProps.weather,
      temp: nextProps.temp,
      shipname: nextProps.shipname,
      ship_id: nextProps.ship_id,
      ship_idx: str,
      type_img: nextProps.type_img,
      type_name: nextProps.type_name,
      id: nextProps.id,
      speed: nextProps.speed,
      status: nextProps.status_name,
      Tanggal: nextProps.Tanggal,
      Jam: nextProps.Jam,
      DateTime: nextProps.DateTime,
      Lintang: nextProps.Lintang,
      Bujur: nextProps.Bujur,
      Magnitude: nextProps.Magnitude,
      Kedalaman: nextProps.Kedalaman,
      Wilayah: nextProps.Wilayah,
      Potensi: nextProps.Potensi,
      Dirasakan: nextProps.Dirasakan,
      Coordinates: nextProps.Coordinates,
      Shakemap: nextProps.Shakemap,
      description: nextProps.description,
      address: nextProps.address,
      gid: nextProps.gid,
      dimensi: nextProps.dimensi,
      subdimensi: nextProps.subdimensi,
      district: nextProps.district,
      subdistrict: nextProps.subdistrict,
      category: nextProps.category,
      destination: nextProps.destination,
      rot: nextProps.rot,
      width: nextProps.width,
      length: nextProps.length,
      flag: nextProps.flag,
      date_created: nextProps.date_created,
      dwt: nextProps.dwt,
      openAlert: false,
      openAlertDeparture: false
    });
  }

  handleCloseAlert = () => {
    this.setState({ openAlert: !this.state.openAlert });
  };
  handleCloseAlertDeparture = () => {
    this.setState({ openAlertDeparture: !this.state.openAlertDeparture });
  };

  componentDidMount() {
    let tryapi = true;
    var detail = document.getElementById("popup-detail");
    var fav = document.getElementById("add-fav");
    var portdeparture = document.getElementById("port-departure");
    var portarrival = document.getElementById("port-arrival");

    portdeparture.onclick = () => {
      this.setState({ openAlertDeparture: true });
    };
    portarrival.onclick = () => {
      this.setState({ openAlert: true });
    };

    detail.onclick = () => {
      this.setState({ open: !this.state.open });
      if (this.state.open == true && tryapi == true) {
        fetchVesselbyship_id(this.state.ship_id)
          .then(response => {
            let datanya = response.data.results;

            datanya.map(e => {
              fetchVesselDetailMT(e.mmsi)
                .then(response => {
                  let datanya = JSON.stringify(response.data);

                  response.data.map(e => {
                    this.setState({
                      mmsi: e[0],
                      lat: e[1],
                      lon: e[2],
                      speed: e[3],
                      heading: e[4],
                      course: e[5],
                      status: e[6],
                      timestamp: e[7],
                      shipname: e[8],
                      shiptype: e[9],
                      type_name: e[10],
                      ais_type_summary: e[11],
                      imo: e[12],
                      callsign: e[13],
                      flag: e[14],
                      port_id: e[15],
                      port_unlocode: e[16],
                      current_port: e[17],
                      last_port_id: e[18],
                      last_port_unlocode: e[19],
                      last_port: e[20],
                      last_port_time: e[21],
                      destination: e[22],
                      eta: e[23],
                      eta_calc: e[24],
                      length: e[25],
                      width: e[26],
                      draught: e[27],
                      grt: e[28],
                      next_port_id: e[29],
                      next_port_unlocode: e[30],
                      next_port_name: e[31],
                      next_port_country: e[32],
                      dwt: e[33],
                      year_built: e[34],
                      dsrc: e[35]
                    });
                  });
                })
                .catch(error => {
                  console.log(error);
                  // this.props.history.push("/pages/login#logout");
                });
            });
          })
          .catch(error => {
            console.log(error);
            // this.props.history.push("/pages/login#logout");
          });
      }
    };

    fav.onclick = () => {
      this.props.pushLoader(true);
      const newdata = {
        shipid: this.state.ship_id,
        name: this.state.shipname,
        latitude: this.state.lat,
        longitude: this.state.lon
      };
      pushFavorite(newdata)
        .then(response => {
          this.props.pushLoader(false);
        })
        .catch(error => {
          console.log(error);
          this.props.history.push("/pages/login#logout");
        });
    };
  }

  toggleDrawer = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <div
          style={{
            backgroundColor: "#192964"
          }}
        >
          <div style={{ padding: "10px" }}>
            <font color="white">
              <b>{this.state.baloonTitle}</b>
            </font>
          </div>
        </div>
        <div hidden={this.state.geomtype === "vessel" ? false : true}>
          <div>
            <NavLink to={`/cctv/?shipid=${this.state.ship_id}`}>
              <img
                height="200"
                width="100%"
                src={`https://images.marinetraffic.com/collection/${
                  this.state.ship_id
                }.webp?size=800`}
              />
            </NavLink>
          </div>

          <AppBar position="static">
            <Toolbar style={{ minHeight: 43 }}>
              <IconButton
                edge="start"
                size="small"
                className={classes.menuButton}
                color="inherit"
                aria-label="menu"
                id="popup-detail"
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title} />
              <div align="right" style={{ width: "100%" }}>
                <Button
                  color="primary"
                  variant="contained"
                  startIcon={<BookmarkBorderIcon />}
                  id="add-fav"
                >
                  <small>Favorite</small>
                </Button>
              </div>
            </Toolbar>
          </AppBar>
          <Collapse in={this.state.open}>
            <Grid container spacing={1} style={{ padding: 10 }}>
              <Grid item xs={6}>
                <font size={5}>
                  {this.state.last_port_unlocode} <b>{this.state.last_port}</b>
                </font>
              </Grid>
              <Grid item xs={6} align="right">
                <font size={5}>
                  {this.state.next_port_unlocode}{" "}
                  <b>{this.state.next_port_name}</b>
                </font>
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={2} align="right">
                <PlayCircleFilledWhiteIcon color="action" />
              </Grid>
              <Grid item xs={8}>
                <Slider value={56} aria-labelledby="continuous-slider" />
              </Grid>
              <Grid item xs={2}>
                <FlagRoundedIcon color="action" />
              </Grid>
            </Grid>
            <div style={{ height: 300, overflow: "scroll" }}>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableBody striped={true}>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>ETA</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.eta}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>ETA CALC</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.eta_calc}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>LAST UPDATE</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.timestamp} </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>TYPE NAME</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.type_name}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>AIS TYPE SUMMARY</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.ais_type_summary} </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>IMO</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.imo}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>CALLSIGN</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.callsign} </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>FLAG</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.flag}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>PORT UNLOCODE</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.port_unlocode} </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>CURRENT PORT</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.current_port}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>LAST PORT TIME</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.last_port_time}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>DESTINATION</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.destination}</small>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>LENGTH</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.length}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>WIDTH</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.width}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>DRAUGHT</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.draught}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>GRT</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.grt}</small>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>NEXT PORT COUNTRY</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.next_port_country}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>DWT</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.dwt}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>YEAR BUILT</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.year_built}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>DSRC</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.dsrc}</small>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Collapse>
          <Collapse in={!this.state.open}>
            <div style={{ height: 300, overflowY: "scroll" }}>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableBody striped={true}>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>SHIP ID</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.ship_idx} </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>FLAG</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.flag} </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>LAST SEEN</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.date_created} WIB </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>SPEED</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>
                          {parseInt(this.state.speed).toFixed(0)} Knot{" "}
                        </small>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>DESTINATION</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.destination} </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>WEATHER/TEMP</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>
                          {this.state.weather}/{this.state.temp}
                          ºC{" "}
                        </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>STATUS</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.status_name}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>COURSE</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.course}º</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>ELAPSED</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.elapsed}</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>HEADING</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.heading}º</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>TYPE</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>
                          {this.getNameshiptype(this.state.typenya)}
                        </small>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>LATITUDE</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.lat}º</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>LONGITUDE</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.lon}º</small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>DWT</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.dwt} </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>WIDTH</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.width} </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {" "}
                        <small>LENGTH</small>
                      </TableCell>
                      <TableCell align="right">
                        <small>{this.state.length} </small>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Collapse>
        </div>
        <div
          hidden={this.state.geomtype === "gempa" ? false : true}
          style={{ height: 400 }}
        >
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <TableBody striped={true}>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Tanggal</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Tanggal} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Jam</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Jam} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>DateTime</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.DateTime}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Coordinates</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Coordinates}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Lintang</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Lintang}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Bujur</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Bujur}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Magnitude</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Magnitude}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Kedalaman</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Kedalaman} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Wilayah</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Wilayah} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Potensi</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Potensi} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Dirasakan</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Dirasakan} </small>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div hidden={this.state.geomtype === "port" ? false : true}>
          <div>
            <img
              height="200"
              width="100%"
              src={`https://images.marinetraffic.com/collection/${
                this.state.gid
              }.webp?size=800`}
            />
          </div>
          <div style={{ height: 300 }}>
            <TableContainer>
              <Table size="small" aria-label="a dense table">
                <TableBody striped={true}>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {" "}
                      <small>Type: {this.state.geomtype}</small>
                    </TableCell>
                    <TableCell align="right">
                      <small>PORTID: {this.state.gid} </small>
                    </TableCell>
                  </TableRow>

                  <TableRow style={{ background: "#192964" }}>
                    <TableCell component="th" scope="row">
                      {" "}
                      <small style={{ color: "#ffff" }}>
                        <span id="port-arrival" style={{ cursor: "pointer" }}>
                          Port Arrival List >>{" "}
                        </span>
                      </small>
                      <Dialog
                        maxWidth={"md"}
                        open={this.state.openAlert}
                        aria-labelledby="form-dialog-title"
                      >
                        <DialogTitle id="form-dialog-title">
                          Port Arrival List
                        </DialogTitle>
                        <DialogContent>
                          <Grid item xs={12} sm={12} md={12}>
                            <Arrivallist gid={this.state.gid} />
                          </Grid>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.handleCloseAlert}
                            color="danger"
                            round
                          >
                            Close
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </TableCell>
                    <TableCell align="right">
                      <small style={{ color: "#ffff" }}>
                        {" "}
                        {this.state.current_offset}{" "}
                      </small>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: "#192964" }}>
                    <TableCell component="th" scope="row">
                      {" "}
                      <small style={{ color: "#ffff" }}>
                        <span id="port-departure" style={{ cursor: "pointer" }}>
                          Port Departure List >>{" "}
                        </span>
                      </small>
                      <Dialog
                        maxWidth={"md"}
                        open={this.state.openAlertDeparture}
                        aria-labelledby="form-dialog-title"
                      >
                        <DialogTitle id="form-dialog-title">
                          Port Departure List
                        </DialogTitle>
                        <DialogContent>
                          <Grid item xs={12} sm={12} md={12}>
                            <Departurelist gid={this.state.gid} />
                          </Grid>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.handleCloseAlertDeparture}
                            color="danger"
                            round
                          >
                            Close
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: "#192964" }}>
                    <TableCell component="th" scope="row">
                      {" "}
                      <small style={{ color: "#ffff" }}>
                        Country: {this.state.district}
                      </small>
                    </TableCell>
                    <TableCell align="right">
                      <small style={{ color: "#ffff" }}>
                        Location: {this.state.address}{" "}
                      </small>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: "#192964" }}>
                    <TableCell component="th" scope="row" colSpan={2}>
                      {" "}
                      <small style={{ color: "#ffff" }}>
                        More Info :{this.state.description}{" "}
                      </small>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    );
  }
}

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

Poipopup.propTypes = {
  content: PropTypes.func,
  pushLoader: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    blocking: state.loader
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLoader }
)(withStyles(makeStyles)(Poipopup)));
